module.exports = __webpack_public_path__ + "assets/img/icon-total-price-white.svg";